import {
	findAll,
	find,
	show,
	transliterate,
	letterRatio,
	toggleClass,
	removeClass,
	addClass,
	hasClass,
	isHidden,
	findID,
	isJsonString,
	output_products_count
} from "../../../../../modules/vegas/js/util";
import Catalog from "../catalog/catalog";

/**
 * ФИЛЬТРЫ
 * В наборе установите дата атрибут data-trigger="submit", для отработки метода submit()
 */
class VGCatalogFilters {
	constructor(container) {
		this.container = container;
		this.inputs = {};
		this.tmSubmit = null;
		this.settings = {
			checkbox: {
				perView: 7, // когда показывать чекбокс выбрать все
				enableCheckAll: true
			},
			search: {
				perSearch: 10, // когда показывать поиск
				enableSearch: true
			}
		}
	}

	/**
	 * Инициализируем фильтрацию
	 */
	init() {
		let self = this;

		// Собираем наборы
		let $sets = [...findAll('.catalog-filters--item', this.container)];
		if ($sets.length) {
			$sets.forEach(function ($set) {
				let type = $set.dataset.type;

				switch (type) {
					case 'checkbox':
						self._setCheckbox($set);
						break;
				}
			});
		}

		this.inputs = this._getInputs();
	}

	/**
	 * Чекает выбранный параметр
	 * @param self
	 */
	check(self) {
		const _this = this;

		if (!hasClass(self, 'checkAll')) {
			toggleClass(self, 'checked');
		} else {
			let $container = self.closest('.catalog-filters--item');

			let $boxes = find('.catalog-filters--item-body', $container);
			if ($boxes) {
				$boxes = [...findAll('.catalog-filters-checkbox--label', $boxes)];
			}

			if (hasClass(self, 'checked')) {
				if ($boxes.length) {
					$boxes.forEach(function (el) {
						if (!isHidden(el)) {
							removeClass(el, 'checked');
						}
					});
				}

				removeClass(self, 'checked');
			} else {
				if ($boxes.length) {
					$boxes.forEach(function (el) {
						if (!isHidden(el)) {
							addClass(el, 'checked');
						}
					});
				}
				addClass(self, 'checked');
			}
		}

		let $set = self.closest('.catalog-filters--item'),
			$checkedParams = [...findAll('.catalog-filters--item-body .checked', $set)];

		if ($set.dataset.param in this.inputs) {
			delete this.inputs[$set.dataset.param];
		}

		if ($checkedParams.length) {
			let arr = [];

			$checkedParams.forEach(function (el) {
				arr.push(el.dataset.value)
			});

			this.inputs[$set.dataset.param] = arr.join();
		}

		_this.actualizeValues();
		_this.setApplied();

		if ($set.dataset.trigger === 'submit') {
			_this.submit();
		}
	}

	/**
	 * Чекает выбранный параметр
	 * @param self
	 */
	radio(self) {
		const _this = this;

		let $set = self.closest('.catalog-filters--item'),
			$checkedParams = find('.catalog-filters--item-body .checked', $set);

		removeClass($checkedParams, 'checked');
		addClass(self, 'checked');

		this.inputs[$set.dataset.param] = self.dataset.value;

		_this.actualizeValues();
		_this.setApplied();

		if ($set.dataset.trigger === 'submit') {
			_this.submit(500);
		}
	}

	/**
	 * Range Slider
	 * @param self
	 */
	range(self) {
		const _this = this;

		let $set = self.closest('.catalog-filters--item'),
			range = $set.querySelector('input[name="range"]'),
			type = self.dataset.number,
			val = parseInt(self.value) || null,
			min = parseInt(self.getAttribute('min')) || null,
			max = parseInt(self.getAttribute('max')) || null;

		if (min && val < min) {
			val = min;
		}

		if (max && val > max) {
			val = max;
		}

		if (range) {
			if (type === 'from') {
				range.setAttribute('data-from', val);
			}
			if (type === 'to') {
				range.setAttribute('data-to', val);
			}
		}

		this.inputs[$set.dataset.param] = range.dataset.from + ',' + range.dataset.to;

		this.actualizeValues();
		this.setApplied();

		if ($set.dataset.trigger === 'submit') {
			_this.submit(500);
		}
	}

	/**
	 * Search parameter
	 * @param self
	 */
	search(self) {
		let $filter = self.closest('.catalog-filters--item'),
			$values = [...findAll('[data-value]', $filter)],
			val = self.value;

		if ($values.length) {
			$values.forEach(el => el.classList.remove('d-none'));
		}

		if (val.length) {
			val = val.trim();
			val = val.toLowerCase();

			let vals = [
				val,
				transliterate(val, false),
				transliterate(val, true),
				letterRatio(val),
				letterRatio(val, true),
			];

			$values.filter(function (el) {
				let param = el.innerText.toLowerCase();

				return vals.filter(function (element) {
					return param.indexOf(element) !== -1;
				}).length === 0;
			}).forEach(el => el.classList.add('d-none'));
		}
	}

	/**
	 * Отправляем данные на сервер
	 * @param timeout
	 */
	submit(timeout = 0) {
		this._setInputs(this.inputs);

		let submit = () => {
			let form = findID('catalog-filter-form');
			let btnTotals = document.getElementById('sidebar-filters')?.querySelector('.btn-show-products')

			if (btnTotals) btnTotals.disabled = true;

			new Catalog(form.action)
				.withHeaders({
					'V-View-Filters': false,
				})
				.load((data) => {
					if (btnTotals) {
						btnTotals.innerText = data.totals ? ('Показать ' + output_products_count(data.totals)) : 'Нет товаров';
						btnTotals.disabled = false;
					}
				});
		}

		if (timeout) {
			clearTimeout(this.tmSubmit);
			this.tmSubmit = setTimeout(submit, timeout);
		} else {
			submit();
		}
	}

	/**
	 * Сбрасываем все что было выбрано
	 * @param set
	 */
	reset(set = null) {
		const _this = this;

		if (set) {
			let param = set.dataset.param;

			_this.unselect(set);

			delete _this.inputs[param];
		} else {
			let $containerFilters = findID('catalog-filters');

			if ($containerFilters) {
				let filters = [...findAll('[data-param]')];

				if (filters.length) {
					filters.forEach(function (filter) {
						let param = filter.dataset.param;

						_this.unselect(filter);
						delete _this.inputs[param];
					});
				}
			}
		}

		this.actualizeValues();
		this.setApplied();

		return _this.submit();
	}

	select() {
		let self = this;

		let $sets = [...findAll('.catalog-filters .catalog-filters--item, .catalog-filters--clone .catalog-filters--item', this.container)];
		$sets.forEach($set => {
			let set = $set.dataset.set,
				type = $set.dataset.type;

			if (set === 'multiple') {
				let param = $set.dataset.param,
					inputs = self._getInputs(param);

				if (inputs && inputs.length) {
					inputs = inputs.split(',');

					if (type === 'checkbox' || type === 'radio') {
						let $setBody = find('.catalog-filters--item-body', $set);

						[...findAll('.checked', $setBody)].forEach((el => el.classList.remove('checked')));

						inputs.forEach(function (value) {
							let $elValue = find('[data-value="' + value + '"]', $setBody);
							if ($elValue) {
								addClass($elValue, 'checked')
							}
						})

						let $filters = [...findAll('span.catalog-filters-checkbox--label', $setBody)];
						if (inputs.length === $filters.length) {
							let $elCheckAll = find('.checkAll', $set);
							if ($elCheckAll) addClass($elCheckAll, 'checked')
						}
					}
				}
			} else if (set === 'select' || set === 'single') {
				let param = $set.dataset.param,
					inputs = self._getInputs(param),
					$checkedValue = find('[data-value="' + inputs + '"]', $set);

				if ($checkedValue) {
					let $elCheck = find('.checked', $set);
					if ($elCheck) {
						removeClass($elCheck, 'checked');
					}
					addClass($checkedValue, 'checked');
				}
			}
		});
	}

	/**
	 * Снимает выбранные параметры у фильтра
	 * @private
	 * @param filter
	 */
	unselect(filter) {
		let set = filter.dataset.set,
			type = filter.dataset.type;

		if (type === 'range') {
			let $inputs = [...findAll('input', filter)];
			if ($inputs.length) {
				$inputs.forEach(function (input) {
					input.value = '';
				});
			}
		}

		if (set === 'multiple') {
			if (type === 'checkbox' || type === 'radio') {
				[...findAll('[data-value]', filter)].forEach(el => removeClass(el, 'checked'));

				let checkAll = find('.catalog-checkbox--label.checkAll', filter);
				if (checkAll) {
					removeClass(checkAll, 'checked')
				}
			}
		} else if (set === 'select' || set === 'single') {
			[...findAll('.checked', filter)].forEach(el => removeClass(el, 'checked'))
		}
	}

	/**
	 * Получаем все выбранные фильтры
	 * @param param
	 * @returns {*|{}}
	 * @private
	 */
	_getInputs(param = null) {
		let $mainContainer = findID('catalog-filters') || findID('catalog-filters-mobile');
		let INPUTS = {};
		if ($mainContainer) {
			INPUTS = $mainContainer.dataset.selectedFilters;

			if (isJsonString(INPUTS)) {
				INPUTS = JSON.parse(INPUTS);
			}
		}

		if (param) {
			return INPUTS[param];
		}

		return INPUTS;
	}

	/**
	 * Подготавливаем все выбранные параметры в форму для отправки на сервер
	 * @private
	 */
	_setInputs(inputs) {
		let $form = findID('catalog-filter-form');
		if ($form) {
			if (!inputs) inputs = {};

			[...findAll('input:not(.static)', $form)].forEach((el) => el.remove());

			if (Object.keys(inputs).length > 0) {
				function appendInputs(objects) {
					for (let key in objects) {
						let value = objects[key];

						if (value !== '' && typeof value !== 'object' && typeof value !== 'function') {
							$form.insertAdjacentHTML('afterbegin', '<input type="hidden" name="' + key + '" value="' + value + '">');
						}
					}
				}

				appendInputs(inputs);
			}
		}
	}

	getActualSelected() {
		let self = this,
			$filters = [...findAll('.catalog-filters--item')],
			set = [];

		$filters.forEach(function (el) {
			let type = el.dataset.type,
				param = el.dataset.param,
				title = el.dataset.title,
				item = {
					title: '',
					values: '',
					values_ids: '',
					id: '',
					type: '',
					postfix: '',
				};

			if (param in self.inputs) {
				item = {
					title: title,
					id: param,
					type: type,
				}

				if (type === 'range') {
					item.values = self.inputs[param].replace(',', ' - ');

					let $postfix = find('[data-postfix]', el);
					if ($postfix) {
						item.postfix = $postfix.dataset.postfix || '';
					}
				} else if (type === 'checkbox') {
					let values = self.inputs[param].split(','),
						title = [];

					for (let value of values) {
						let $value = find('[data-value="' + value + '"]', el);
						if ($value) {
							title.push($value.dataset.valueTitle);
						}
					}

					item.values = title.join('; ')
					item.values_ids = values.join(',');
				}

				set.push(item);
			}
		});

		return set;
	}

	/**
	 * Вывод выбранных параметров
	 * @param inputs
	 * @returns {boolean}
	 * @private
	 */
	setApplied(inputs = null) {
		if (inputs === null) {
			inputs = this.getActualSelected();
		}

		let $mainContainer = findID('catalog-filters');

		if ($mainContainer) {
			let $filters = [...findAll('.catalog-filters--item')],
				$appliedFilters = find('.catalog-filters-applied'),
				$appliedFiltersList = null,
				set = this.getActualSelected();

			if ($appliedFilters) {
				$appliedFiltersList = find('.list-filters-applied', $appliedFilters);

				if (inputs) {
					addClass($appliedFilters, 'show');
				} else {
					removeClass($appliedFilters, 'show');
				}
			}

			if ($filters.length && $appliedFilters && $appliedFiltersList) {
				let newContent = getListContent();
				$appliedFiltersList.innerHTML = '';
				$appliedFiltersList.append(newContent);

				function getListContent() {
					let fragment = new DocumentFragment();

					for (let filter of set) {
						let li = document.createElement('li'),
							title = document.createElement('span'),
							toggle = document.createElement('a'),
							postfix = '';

						li.classList.add('list-item');
						li.classList.add('catalog-filters-applied--item');

						if (filter.postfix) {
							postfix = filter.postfix
						}

						let values = filter.values.split(';'),
							str_cnt_values = '';

						if (values.length > 1) {
							let ctn = values.length - 1
							str_cnt_values = ` +${ctn}`;
						}

						title.classList.add('title');
						title.innerHTML = filter.title + ': <span class="values">' + values.shift() + str_cnt_values + ' ' + postfix + '</span>';

						toggle.classList.add('toggle');
						toggle.setAttribute('id', filter.id);
						toggle.setAttribute('data-dismiss', 'filter-applied');
						toggle.innerHTML = '<i class="fa-thin fa-times"></i>';

						li.prepend(title);
						li.append(toggle)

						fragment.append(li);
					}

					return fragment;
				}

				if (set.length > 1) {
					let fragment = new DocumentFragment();

					let li = document.createElement('li'),
						toggle = document.createElement('a');

					toggle.classList.add('clear');
					toggle.setAttribute('href', '#');
					toggle.setAttribute('data-dismiss', 'filter-applied-all');
					toggle.innerHTML = 'Сбросить';

					li.classList.add('list-item');
					li.classList.add('catalog-filters-applied--item');

					li.append(toggle);
					fragment.append(li);

					$appliedFiltersList.append(fragment);
				}


				return true;
			}
		}
	}

	/**
	 * Инициализация чекбоксов
	 * @param $set
	 * @private
	 */
	_setCheckbox($set) {
		let self = this;

		let $checkboxes = [...findAll('.catalog-filters-checkbox--label', $set)];
		if ($checkboxes.length >= self.settings.search.perSearch && self.settings.search.enableSearch) {
			let $searchPanel = find('[data-filter-panel=search]', $set);
			if ($searchPanel) {
				show($searchPanel);
			}
		}

		if ($checkboxes.length >= self.settings.checkbox.perView && self.settings.checkbox.enableCheckAll) {
			let $searchPanel = find('[data-filter-panel=checkAll]', $set);
			if ($searchPanel) {
				show($searchPanel);
			}
		}
	}

	actualizeValues(selected = null) {
		if (selected === null)
			selected = this.getActualSelected();

		let res = {};
		selected.forEach(el => {
			if (el.type === 'range') {
				res[el.id] = el.values.replace(' - ', ',');
			} else {
				res[el.id] = el.values_ids || el.values;
			}
		});

		let $mainContainer = findID('catalog-filters');
		if ($mainContainer) {
			$mainContainer.dataset.selectedFilters = JSON.stringify(res);
		}
	}

	setInputValue(param, value) {
		let $mainContainer = findID('catalog-filters');
		let data = $mainContainer.dataset.selectedFilters;
		data = JSON.parse(data);

		if (value) {
			data[param] = value;
		} else {
			delete data[param];
		}

		$mainContainer.dataset.selectedFilters = JSON.stringify(data);
	}
}

export default VGCatalogFilters;
